export default function loadOrganizationName(organizationName: string) {
    window.location.assign(`${window.location.origin}/${organizationName}/portal_`);
}
